<script lang="ts">
import { defineComponent } from 'vue'
export default defineComponent({
  name: 'App',
})
</script>
/* * 苏州海管家物流科技有限公司（https://www.hgj.com/）. *
苏公网安备32059002003385号 © 2015-2023 Hgj.com All Rights Reserved. |
苏ICP备15030950号. * @Date: 2023.09.05. * @Author * @Description 恪保 - 项目入口
. **/
<script lang="ts" name="App" setup>
import { en, zhCn, vi } from '@hgj/element-plus/es/locale'
import {
  DialogWrapper,
  ConfigProvider,
  en as componentEn,
  zhCn as componentZhCn,
} from '@stroybrooke-business-tools/components'
import { useAuthStore } from '@/store/authStore'
import { useActivityNewCustomer } from '@/hooks/useActivityNewCustomer'
import { WujieVue } from '@stroybrooke-business-tools/plugins'
/**
 *@Description 键盘监听 事件  .
 *@Return .
 */
import { useRoute } from 'vue-router'
import { getCurrentLanguage } from '@hgj/common-tools'
import { expandHeader, isGlobal } from './utils/constant'
const route = useRoute()
const user = useAuthStore()

watch(route, () => {
  user.setUInfo()
})

// 执行新客活动相关逻辑
useActivityNewCustomer()

const prefix = import.meta.env.VITE_APP_PREFIX
const ENV = prefix.split('-')[0]
const SettlementPaymentUrl = computed(() => {
  if (isGlobal) {
    return `${import.meta.env.VITE_APP_HOST}/mall-center/modules/settlement`
  } else {
    return `https://${prefix === 'prod-' ? '' : prefix}mall.hgj.com/modules/settlement`
  }
})

let epLocale = ref(zhCn)
const lang = getCurrentLanguage() || 'zh-CN'
const langMap: { [key: string]: any } = {
  'zh-CN': zhCn,
  vi: en,
  en: en,
}
epLocale.value = langMap[lang || 'zh-CN']

const stroybrookeConfig: any = { ENV, HEADERS: expandHeader }
if (isGlobal) {
  stroybrookeConfig.BASE_URL = import.meta.env.VITE_BASE_URL + '/all-port'
}
</script>

<template>
  <ConfigProvider
    :config="stroybrookeConfig"
    :locale="lang === 'zh-CN' ? componentZhCn : componentEn"
  >
    <el-config-provider :locale="epLocale" :z-index="90000">
      <router-view></router-view>
    </el-config-provider>
  </ConfigProvider>
  <WujieVue
    name="SettlementPayment"
    :url="SettlementPaymentUrl"
    productCode="saas-insurance"
    width="0"
    height="0"
  >
  </WujieVue>
  <DialogWrapper></DialogWrapper>
</template>

<style lang="scss">
#app {
  font-family:
    PingFang SC,
    Lantinghei SC,
    Microsoft YaHei,
    HanHei SC,
    Helvetica Neue,
    Open Sans,
    Arial,
    Hiragino Sans GB,
    微软雅黑,
    STHeiti,
    WenQuanYi Micro Hei,
    SimSun,
    sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  box-sizing: border-box;
}
</style>
